export default __webpack_public_path__ + "static/media/icon_fechas.70d12a85.svg";